"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SelectMenuItemSelectedIcon = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/component/SelectMenuItemSelectedIcon.svg"));
var _DownLine = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/direction/DownLine.svg"));
var _CloseCircleLine = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/CloseCircleLine.svg"));
var _ahooks = require("ahooks");
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _devConsoleLog = require("../_util/devConsoleLog");
var _chips = _interopRequireDefault(require("../chips"));
var _icon = _interopRequireDefault(require("../icon"));
var _textField = _interopRequireDefault(require("../text-field"));
var _otherRender = require("./otherRender");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Select = props => {
  const {
    label,
    placeholder,
    type = 'outline',
    size = 'm',
    disabled,
    optionsLoading,
    loading,
    error,
    mText,
    prefix,
    allowClear,
    children,
    onBlur,
    onFocus,
    onDropdownVisibleChange,
    dropdownMatchSelectWidth,
    popupMatchSelectWidth,
    dropdownStyle,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    width,
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-select");
  (0, _react.useEffect)(() => {
    (0, _devConsoleLog.error)(label !== undefined && placeholder !== undefined, 'Select', "'label' and 'placeholder' cannot be shared.");
    (0, _devConsoleLog.error)(mText !== undefined && props.maxTagCount === 'responsive', 'Select', "'mText' and 'maxTagCount ==='responsive'' cannot be shared.");
  }, []);
  const [value, onChange] = (0, _ahooks.useControllableValue)(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  const antdSelectEl = (0, _react.useRef)(null);
  const [shrink, setShrink] = (0, _react.useState)(false);
  const [isFocus, setFocus] = (0, _react.useState)(false);
  const canDoSomething = !disabled;
  const isFocusLatest = (0, _ahooks.useLatest)(isFocus);
  (0, _react.useEffect)(() => {
    if (props.mode) {
      if (isFocusLatest.current) {
        setShrink(true);
      } else {
        setShrink(value === undefined || value.length === 0 ? false : true);
      }
    } else {
      setShrink(value === undefined ? false : true);
    }
  }, [JSON.stringify(value)]);
  const suffixIcon = (0, _react.useMemo)(() => {
    if (mText) {
      return undefined;
    }
    return allowClear && (Array.isArray(value) ? value.length > 0 : value !== undefined) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "suggest/CloseCircleLine",
      onClick: () => {
        onChange(undefined);
      },
      style: {
        cursor: 'pointer',
        zIndex: 2,
        pointerEvents: 'auto'
      }
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "direction/DownLine",
      fontSize: 16
    });
  }, [mText, allowClear, value]);
  const latestValue = (0, _ahooks.useLatest)(value);
  const AntdSelectRender = /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select, {
    ...restProps,
    ref: antdSelectEl,
    placeholder: placeholder,
    value: value,
    onChange: (value, options) => {
      onChange(value, options);
    },
    disabled: disabled,
    className: (0, _classnames.default)('content', {
      ["".concat(size)]: !!size,
      ["with-prefixIcon"]: !!prefix,
      ["with-suffixIcon"]: !!true
    }),
    popupClassName: "".concat(baseClassName, "-dropdown"),
    variant: "borderless",
    onFocus: e => {
      onFocus === null || onFocus === void 0 || onFocus(e);
      if (!props.mode) {
        setFocus(true);
        canDoSomething && shrink === false && setShrink(true);
      }
    },
    onBlur: e => {
      onBlur === null || onBlur === void 0 || onBlur(e);
      if (!props.mode) {
        setFocus(false);
        (value === undefined || value === '') && shrink === true && setShrink(false);
      }
    },
    onDropdownVisibleChange: open => {
      if (props.mode) {
        if (open) {
          setFocus(true);
          canDoSomething && shrink === false && setShrink(true);
        } else {
          var _latestValue$current;
          setFocus(false);
          !((_latestValue$current = latestValue.current) !== null && _latestValue$current !== void 0 && _latestValue$current.length) && shrink === true && setShrink(false);
        }
      }
      onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(open);
    },
    allowClear: false,
    suffixIcon: false,
    menuItemSelectedIcon: restProps.mode === 'multiple' || restProps.mode === 'tags' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "component/SelectMenuItemSelectedIcon",
      fontSize: 16
    }) : undefined,
    notFoundContent: /*#__PURE__*/(0, _jsxRuntime.jsx)(_otherRender.NotFoundContent, {
      optionsLoading: optionsLoading
    }),
    children: optionsLoading ? undefined : children,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth,
    popupMatchSelectWidth: popupMatchSelectWidth,
    dropdownStyle: dropdownStyle
  });
  if (label === undefined) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_chips.default, {
      type: type,
      size: size,
      disabled: disabled,
      mText: mText,
      error: error,
      loading: loading,
      prefix: prefix,
      suffix: suffixIcon,
      style: style,
      width: width,
      noPadding: true,
      className: (0, _classnames.default)(className, "".concat(baseClassName, "-forChips")),
      children: AntdSelectRender
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_textField.default, {
    label: label,
    type: type,
    shrink: shrink,
    isFocus: isFocus,
    size: size,
    disabled: disabled,
    mText: mText,
    error: error,
    loading: loading,
    prefix: prefix,
    suffix: suffixIcon,
    style: style,
    width: width,
    className: (0, _classnames.default)(className, baseClassName),
    children: AntdSelectRender
  });
};
Select.Option = _antd.Select.Option;
Select.OptGroup = _antd.Select.OptGroup;
var _default = exports.default = Select;